import { render, staticRenderFns } from "./SelectStatusEdi.vue?vue&type=template&id=1af94fdf&"
import script from "./SelectStatusEdi.vue?vue&type=script&lang=ts&"
export * from "./SelectStatusEdi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports